import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FieldEdit } from "components/forms/part/FieldEdit/FieldEdit";
import { FieldPopover } from "components/forms/part/FieldPopover/FieldPopover";
import { FormFieldWrapper } from "components/forms/part/FormFieldWrapper/FormFieldWrapper";
import { FormInputWrapper } from "components/forms/part/FormInputWrapper/FormInputWrapper";
import { FormLabel } from "components/forms/part/FormLabel/FormLabel";
import { FormTextProps, FormTextState } from "components/forms/part/FormText/types";
import { InputType } from "enums";
import { Component, SyntheticEvent } from "react";
import t from "translations/translator";
import utils from "util/utils";

export class FormText extends Component<FormTextProps> {
	state:FormTextState = { edit: true, overrideDisabled: false, inputValue: "" }

	render():JSX.Element{
		const label = this.props.label;
		const input = this.props.input;
		const hidden = this.props.hidden;
		const dataAttrs = this.props.input.dataAttributes ? utils.helpers.convertToDataAttributes(this.props.input.dataAttributes) : null;
		const inputClass = input.class ? input.class : [];

		if(this.state.overrideDisabled){ input.disabled = this.state.edit; }

		let min = 0;
		let max = 999999;

		if(input.type === InputType.NUMBER){
			min = input.min ? input.min : 0;
			max = input.max ? input.max : 999999;
		}

		inputClass.push("field-input");
		if(hidden && this.state.inputValue !== hidden.value){ inputClass.push("hasChanged"); }

		return (
			<FormFieldWrapper label={label} minimalist={input.minimalist} width={this.props.fieldWidth}>
				<FormLabel {...this.props.label} />
				<FormInputWrapper>
					<input
						id={input.id}
						type={input.type}
						className={inputClass.join(" ")}
						name={input.name}
						placeholder={input.placeholder ? t.t(input.placeholder) : undefined }
						autoComplete={input.autoComplete}
						value={this.state.inputValue}
						disabled={input.disabled}
						required={input.required}
						onChange={this.doChangeEvents}
						min={min}
						max={max}
						{...dataAttrs}
					/>
					{ hidden && <input
						type="hidden"
						name={hidden.name}
						value={hidden.value}
					/> }
					{input.showEditButton && <FieldEdit edit={this.state.edit} action={this.editClicked} /> }
					{input.showPopover
						? <FieldPopover id={input.popoverId} icon={faQuestionCircle} content={input.popoverContent} hide={input.popoverHidden} />
						: null
					}
				</FormInputWrapper>
			</FormFieldWrapper>
		);
	}

	componentDidMount():void{
		this.setState((old:FormTextState):FormTextState => { return { ...old, inputValue: this.props.input.value }; });
	}

	doChangeEvents = (evt:SyntheticEvent):void => {
		this.checkModified(evt);

		const inputEle = evt.currentTarget as HTMLInputElement;
		this.setState((old:FormTextState):FormTextState => { return { ...old, inputValue: inputEle.value }; });

		const input = this.props.input;
		if(input.events && input.events.onChange){
			input.events.onChange(evt);
		}
	}

	checkModified = (evt:SyntheticEvent):void => {
		const input = evt.currentTarget as HTMLInputElement;
		const hiddenInput = input.nextElementSibling;
		if(!hiddenInput){ return; }

		if(!(hiddenInput instanceof HTMLInputElement)){
			return;
		}

		if(input.value === hiddenInput.value){
			input.classList.remove("hasChanged");
		}else{
			input.classList.add("hasChanged");
		}
	}

	editClicked = ():void => { // Event
		const editable = !this.state.edit;
		this.setState((old:FormTextState):FormTextState => { return { ...old, edit: editable, overrideDisabled: true }; });
	}
}
